
const isToday = (dt) => {
  const today = new Date().getDate()
  return (dt.getDate() == today)
}

export const getTimestamp = (dt) => {
  const localDate = new Date(`${dt}Z`)
  return isToday(localDate)
    ? `Today - ${localDate.toLocaleTimeString([], {timeStyle: 'short'})}`
    : `${localDate.toLocaleString('default', { month: 'short' })} ${localDate.getDate()} - ${localDate.toLocaleTimeString([], {timeStyle: 'short'})}`
}

export const getMenuTimestamp = (dt) => {
  const localDate = new Date(`${dt}Z`)
  return isToday(localDate)
    ? localDate.toLocaleTimeString([], {timeStyle: 'short'})
    : `${localDate.toLocaleString('default', { month: 'short' })} ${localDate.getDate()}`
}

export const diffMinutes = (dt2, dt1) => {
  const t2 = new Date(`${dt2}Z`)
  const t1 = new Date(`${dt1}Z`)
  const diffMs = t2 - t1
  const diffM = diffMs / 60000.0
  //console.log(`Minutes from ${dt1} to ${dt2} = ${diffM}`)
  return diffM
} 
